import RoutesMap from "../../route_control/RouteControl"
import UserLogin from "../../pages/user/user_login/UserLogin"
import Swal from 'sweetalert2'
import { useNavigate } from "react-router"

export const AuthRouteImport = {
    UserLogin,
    RoutesMap,
    useNavigate,
    Swal
}